import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";  
import "primereact/resources/primereact.min.css";
import "./assets/scss/custom.scss"
import "../node_modules/@fortawesome/fontawesome-pro/css/all.min.css"
import Store from "./_stores/index";
import "./_config/i18n";
import 'primeicons/primeicons.css';
import "bootstrap-fileinput/js/fileinput.min.js";
import "bootstrap-fileinput/css/fileinput.min.css";
import "bootstrap-fileinput/js/locales/tr.js";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={Store}>
 
    <Router>
      <App />
    </Router>
    </Provider>
);


